module.exports = __webpack_public_path__ + "img/3.5f8465b1.png";